import { render, staticRenderFns } from "./SearchClientModal.vue?vue&type=template&id=44684476&scoped=true&"
import script from "./SearchClientModal.vue?vue&type=script&lang=js&"
export * from "./SearchClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44684476",
  null
  
)

export default component.exports